import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, Autocomplete, TextField } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { ClienteDropDown } from "../../../../../../common/domain/models/cliente_dropdown";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";
import { MaskedInput } from "../../../../../../common/components/masked_inputs/masked_input";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";

/**
 * Header ContasReceber Lista.
 * 
 */

type Props = {
  ddlCentroCusto: CentroCustoDropDown[];
  ddlCliente: ClienteDropDown[];
  ddlBanco: DropDown[];
  ddlOrdemCompra: DropDown[];
  ddlSubconta: DropDown[];
  selectedIdsCentroCusto?: number[];
  selectedIdsCliente?: number[];
  selectedIdsBanco?: number[];
  selectedIdsOrdemCompra?: number[];
  selectedIdsSubconta?: number[];
  status?: number | null;
  titulo?: string | null;
  dataReceberDe?: Date | null;
  dataReceberAte?: Date | null;
  dataRecebidoDe?: Date | null;
  dataRecebidoAte?: Date | null;
  dataCriacaoDe?: Date | null;
  dataCriacaoAte?: Date | null;
  idContratoFinanceiro?: number | null;
  nroConta?: number | null;
  onClearFilters: () => void;
  onStatusChange: (novoStatus: number) => void;
  handleIdCentroCustoChange: (v: number[]) => void;
  handleIdClienteChange: (v: number[]) => void;
  handleIdBancoChange: (v: number[]) => void;
  handleIdOrdemCompraChange: (v: number[]) => void;
  handleIdSubcontaChange: (v: number[]) => void;
  handleIdContratoFinanceiroChange: (v: string | null) => void;
  handleTituloChange: (v: string) => void;
  handleDataReceberRangeChange: (v: Date | null, x: Date | null) => void;
  handleDataRecebidoRangeChange: (v: Date | null, x: Date | null) => void;
  handleDataCriacaoRangeChange: (v: Date | null, x: Date | null) => void;
  handleNroContaChange: (v: string | null) => void;

};


export const Header = ({
  ddlCentroCusto,
  ddlCliente,
  ddlBanco,
  ddlOrdemCompra,
  ddlSubconta,
  selectedIdsCentroCusto = [],
  selectedIdsBanco = [],
  selectedIdsCliente = [],
  selectedIdsOrdemCompra = [],
  selectedIdsSubconta = [],
  status,
  titulo,
  dataReceberDe,
  dataReceberAte,
  dataRecebidoDe,
  dataRecebidoAte,
  dataCriacaoDe,
  dataCriacaoAte,
  idContratoFinanceiro,
  nroConta,
  onClearFilters,
  onStatusChange,
  handleIdCentroCustoChange,
  handleIdClienteChange,
  handleIdBancoChange,
  handleIdOrdemCompraChange,
  handleIdSubcontaChange,
  handleTituloChange,
  handleIdContratoFinanceiroChange,
  handleDataReceberRangeChange,
  handleDataRecebidoRangeChange,
  handleDataCriacaoRangeChange,
  handleNroContaChange,

}: Props) => {

  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  const handleStatusChange = useCallback((e: SelectChangeEvent<number>) => {
    onStatusChange(typeof e.target.value === "string" ? parseInt(e.target.value) : e.target.value)
  }, [onStatusChange]);

  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-2 grid-flow-row-dense">

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 " >
              <div className="w-full">
                <DefaultInput
                  name='titulo'
                  label='Titulo'
                  readOnly={false}
                  value={titulo}
                  onChangeValue={handleTituloChange} />

              </div>

              <div className="w-full">
                <DefaultMultiAutocomplete
                  label='Centro de Custo'
                  value={ddlCentroCusto.filter(x => selectedIdsCentroCusto?.includes(x.id))}
                  options={ddlCentroCusto}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdCentroCustoChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-full">
                <DefaultMultiAutocomplete
                  label='Subconta'
                  value={ddlSubconta.filter(x => selectedIdsSubconta?.includes(x.id))}
                  options={ddlSubconta}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdSubcontaChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-full">
                <DefaultMultiAutocomplete
                  label='Cliente'
                  value={ddlCliente.filter(x => selectedIdsCliente?.includes(x.id))}
                  options={ddlCliente}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdClienteChange(x?.map(y => y.id) ?? [])} />
              </div>

            </div>

            {/* <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">

            </div> */}

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
              <div className="w-[30%]">
                <DefaultMultiAutocomplete
                  label='Banco'
                  value={ddlBanco.filter(x => selectedIdsBanco?.includes(x.id))}
                  options={ddlBanco}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdBancoChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-[30%]">
                <FormControl size="small" fullWidth>
                  <InputLabel id="modulo-dashboard"></InputLabel>
                  <Select
                    labelId="modulo-dashboard"
                    value={status ?? 5}
                    onChange={handleStatusChange}>
                    <MenuItem value={5}>Todas as contas</MenuItem>
                    <MenuItem value={0}>Em aberto</MenuItem>
                    <MenuItem value={1}>Recebidas</MenuItem>
                    <MenuItem value={2}>Outros</MenuItem>
                    <MenuItem value={3}>Atrasadas</MenuItem>
                    <MenuItem value={4}>Recebimento Parcial</MenuItem>
                  </Select>
                </FormControl>
              </div>

              <div className="w-[20%]">

                <DefaultMultiAutocomplete
                  label='Ordem Compra'
                  value={ddlOrdemCompra.filter(x => selectedIdsOrdemCompra?.includes(x.id))}
                  options={ddlOrdemCompra}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdOrdemCompraChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-[20%]">
                <MaskedInput
                  name={'idContratoFinanceiro'}
                  label={'Número de contrato'}
                  mask="00000000"
                  maskPlaceholder="________"
                  value={idContratoFinanceiro?.toString() ?? null}
                  onChange={handleIdContratoFinanceiroChange}
                />
              </div>
            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
              <div className="w-full">
                <DefaultDateRangePickerInput
                  label='Data Receber'
                  dataDe={dataReceberDe ?? null}
                  dataAte={dataReceberAte ?? null}
                  onChange={async (start, end) => {
                    handleDataReceberRangeChange(start, end)
                  }}
                />
              </div>

              <div className="w-full">
                <DefaultDateRangePickerInput
                  label='Data Recebido'
                  dataDe={dataRecebidoDe ?? null}
                  dataAte={dataRecebidoAte ?? null}
                  onChange={async (start, end) => {
                    handleDataRecebidoRangeChange(start, end)
                  }}
                />
              </div>

              <div className="w-full">
                <DefaultDateRangePickerInput
                  label='Data Criação'
                  dataDe={dataCriacaoDe ?? null}
                  dataAte={dataCriacaoAte ?? null}
                  onChange={async (start, end) => {
                    handleDataCriacaoRangeChange(start, end)
                  }}
                />
              </div>

              <div className="w-[40%]">
                <MaskedInput
                  name={'nroConta'}
                  label={'Número conta'}
                  mask="000000000"
                  maskPlaceholder="_________"
                  value={nroConta?.toString() ?? null}
                  onChange={handleNroContaChange}
                />
              </div>
            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 justify-end">
              <div className="w-[180px]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                  buttonColor="yellow"
                  onClick={handleClearFilters}>
                  Limpar filtros
                </PrimaryButton>
              </div>
            </div>

          </div>
        </div>

      </CascateList>
    </>
  );
}